import { Severity } from '@sentry/browser';
import getSentryClient from "./init";
export const getEmceePath = () => {
  if (window.location.href.includes('emcee')) {
    return window.location.hash.split('#')[1];
  }
};
const logLevelToSentrySeverity = {
  info: Severity.Info,
  warn: Severity.Warning,
  error: Severity.Error
};

const sendData = (level, location, message, eventData = {}) => {
  getSentryClient().withScope(scope => {
    scope.clear();

    if (eventData.tags) {
      Object.entries(eventData.tags).forEach(tags => {
        // $FlowIgnore: Flow treats `Object.entries` iterates as mixed type
        scope.setTag(tags[0], tags[1]);
      });
    } // To override emcee iframe url


    const pathname = getEmceePath();

    if (pathname) {
      scope.setTag('url', pathname);
    }

    scope.setTag('location', location);
    scope.setTag('structuredLog', 'true');
    scope.setExtra('eventData', JSON.stringify(eventData));
    getSentryClient().captureMessage("".concat(location, ": ").concat(message), logLevelToSentrySeverity[level]);
    console[level]("".concat(location, ": ").concat(message));
  });
};

const info = (location, message, eventData) => {
  sendData('info', location, message, eventData);
};

const warn = (location, message, eventData) => {
  sendData('warn', location, message, eventData);
};

const error = (location, message, eventData) => {
  sendData('error', location, message, eventData);
};

export default {
  info,
  warn,
  error
};